export function createCheckUserStatus (store, router) {
  return function checkUserStatus (to, from, next) {
    const requiresAuth = to.matched.some(matched => matched.meta && matched.meta.requiresAuth);
    const requiresPro = to.matched.some(matched => matched.meta && matched.meta.requiresPro);

    if (store.getters['user/isLoggedIn']) {
      if (requiresPro) {
        if (store.getters['user/isPro']) {
          next();
        } else {
          window.location.assign(router.resolve({ name: 'homepage' }).href);
        }
      } else {
        next();
      }
    } else if (requiresAuth || requiresPro) {
      window.location.assign(router.resolve({
        name: 'login',
        query: {
          redirect: to.fullPath,
        },
      }).href);
    } else {
      next();
    }
  };
}
